import {
  Component,
  OnInit
}
from '@angular/core';

import {
  CommonModule
}
from '@angular/common';

import {
  FormsModule
}
from '@angular/forms';

import {
  ProductsService
}
from '../../services/products';
import { AdminNavbar }
from '../admin-navbar/admin-navbar';


@Component({
  selector: 'app-products',

  standalone: true,

  imports: [
    CommonModule,
    FormsModule,
    AdminNavbar
  ],

  templateUrl:
    './products.html',

  styleUrl:
    './products.scss'
})

export class Products
implements OnInit
{
  categories: any[] = [];

  product = {

    name: '',

    slug: '',

    description: '',

    mainImage: '',

    featured: false,

    categoryId: null
  };

  imagePreview = '';

  constructor(
    private productsService:
      ProductsService
  ) { }

  ngOnInit()
  {
    this.loadCategories();
  }

  loadCategories()
  {
    this.productsService
      .getCategories()
      .subscribe({

        next: (res: any) =>
        {
          console.log(res);

          this.categories = res;
        },

        error: (err) =>
        {
          console.log(err);
        }
      });
  }

  onFileSelected(event: any)
  {
    const file =
      event.target.files[0];

    if (!file)
      return;

    this.productsService
      .uploadImage(file)
      .subscribe({

        next: (response: any) =>
        {
          console.log(response);

          this.product.mainImage =
            response.secure_url;

          this.imagePreview =
            response.secure_url;

          alert(
            'Slika je uspešno dodata.'
          );
        },

        error: (err) =>
        {
          console.log(err);

          alert(
            'Image upload failed'
          );
        }
      });
  }

  saveProduct()
  {
    if (!this.product.mainImage)
    {
      alert(
        'Please upload image first'
      );

      return;
    }

    console.log(this.product);

    this.productsService
      .createProduct(this.product)
      .subscribe({

        next: (res) =>
        {
          console.log(res);

          alert(
            'Product created successfully'
          );

          this.product = {

            name: '',
            slug: '',
            description: '',
            mainImage: '',
            featured: false,
            categoryId: null
          };

          this.imagePreview = '';
        },

        error: (err) =>
        {
          console.log(err);

          alert(
            'Error creating product'
          );
        }
      });
  }
}